<template>
    <el-dialog
        class="config-dialog-container"
        :title="'添加展示模块'"
        :visible.sync="visible"
        width="720px"
        :close-on-click-modal="false"
        @close="onColse"
    >
        <el-checkbox-group
            v-model="checkedModuleList"
            @change="handleCheckedCitiesChange"
        >
            <el-checkbox
                v-for="item in modList"
                :label="item.code"
                :disabled="checkedModuleList.length<2&&checkedModuleList[0]===item.code"
                border
                :key="item.code"
                >{{ item.label }}</el-checkbox
            >
        </el-checkbox-group>
        <div slot="footer" class="dialog-footer">
            <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
                >全选</el-checkbox
            >
            <div>
                <el-button class="bigData-btn-config-reset" @click="onReset">重置</el-button>
                <el-button class="bigData-btn-config-cancel" @click="onColse">取消</el-button>
                <el-button type="primary" :loading="loading" class="bigData-btn-config-ok" @click="onSure"
                    >确定</el-button
                >
            </div>
        </div>
    </el-dialog>
</template>
<script>
import _ from 'lodash';
import { getList } from '../manageDaskApi';
import { mapGetters } from 'vuex';
export default {
    name: 'ConfigDialog',
    data() {
        return {
            visible: false,
            loading: false,
            checkAll: false,
            cloneCheckedModuleList: [],
            cloneModList: [],
            checkedModuleList: [],
            modList: [],
            isIndeterminate: true,
            pageId: '',
            moduleCode: ''
        };
    },
    computed: {
        ...mapGetters([
            'btnPermissions'
        ])
    },
    methods: {
        open(allList, selectList, pageId, moduleCode) {
            this.visible = true;
            this.modList = allList;
            this.cloneModList = _.cloneDeep(allList);
            this.cloneCheckedModuleList = _.cloneDeep(selectList);
            this.checkedModuleList = selectList;
            this.pageId = pageId;
            this.moduleCode = moduleCode;
        },
        onReset() {
            this.modList = this.cloneModList;
            this.checkedModuleList = this.cloneCheckedModuleList;
        },
        onColse() {
            this.visible = false;
        },
        handleCheckAllChange(val) {
            const allList = [];
            for (const item of this.modList) {
                allList.push(item.code);
            }

            this.checkedModuleList = val ? allList : [allList[0]];
            this.isIndeterminate = false;
        },
        handleCheckedCitiesChange(value) {
            const checkedCount = value.length;
            this.checkAll = checkedCount === this.modList.length;
            this.isIndeterminate =
                checkedCount > 0 && checkedCount < this.modList.length;
        },
        onSure() {
            const checkedModuleList = this.checkedModuleList;
            const modList = this.modList;
            const nameList = [];
            for (const code of checkedModuleList) {
                for (const item of modList) {
                    if (code === item.code) {
                        nameList.push(item.label);
                        break;
                    }
                }
            }
            const pramas = {
                configName: checkedModuleList.join(','),
                configNameCn: nameList.join(','),
                subjectType: this.pageId,
                moduleCode: this.moduleCode
            };
            this.loading = true;
            getList
                .post(pramas)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('保存成功');
                        this.$emit('onConfig', this.checkedModuleList);
                        this.visible = false;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
<style lang="less">
.config-dialog-container {
    .el-checkbox__inner:hover {
        border-color: #2881FF;
    }
    .el-dialog__header {
        background-color: #f2f3f5;
    }
    .el-dialog__title {
        color: #1d2129;
    }
    .el-dialog__body {
        padding: 24px 24px 10px 24px;
    }
    .el-checkbox {
        margin: 0 10px 10px 0 !important;
        padding: 5px 16px;
    }
    .el-checkbox.is-bordered {
        height: 32px;
    }
    .el-checkbox__label {
        height: 22px;
        line-height: 22px;
    }

    .el-checkbox.is-bordered.is-checked {
        border-color: #2881ff;
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #2881ff;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: #2881ff;
        border-color: #2881ff;
    }
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #2881ff;
        border-color: #2881ff;
    }
    .el-dialog__footer {
        padding: 0;
    }
    .dialog-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px;
        box-shadow: inset 0px 1px 0px 0px #f2f3f5;

        .el-checkbox {
            margin: 0 10px 0 0 !important;
            padding: 5px 16px;
        }
    }
    .el-button {
        padding: 9px 15px;
    }
    .el-button--primary {
        color: #ffffff;
        background-color: #2881ff;
        border-color: #2881ff;
    }
    .el-button--primary:active {
        background: #0948d2;
        border-color: #0948d2;
        color: #ffffff;
        outline: none;
    }

    .el-button--primary:hover,
    .el-button--primary:focus {
        background: #4894ff;
        border-color: #4894ff;
        color: #ffffff;
    }
    .el-button--default {
        color: #1d2129;
        background-color: #f2f3f5;
        border-color: #f2f3f5;
        border: 1px solid #e5e6eb;
    }

    .el-button--default:active {
        background: #e5e6eb;
        border-color: #e5e6eb;
        color: #1d2129;
        border: 1px solid #e5e6eb;
    }

    .el-button--default:hover,
    .el-button--default:focus {
        background: #f2f3f5;
        border-color: #f2f3f5;
        color: #1d2129;
        border: 1px solid #e5e6eb;
    }
}
</style>
